"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constant = require("../../../constant");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var CustomButton = _styledComponents.default.button.attrs(function (_ref) {
  var type = _ref.type;
  return {
    type: type || 'button'
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: ", ";\n  color: ", ";\n  font-weight: 700;\n  background: ", ";\n  border-radius: 20px;\n  font-family: 'Brandon Grotesque', Arial, sans-serif;\n  font-size: 13px;\n  line-height: 221.4%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  width: 100%;\n  height: 39px;\n  padding: 0 31px;\n  border: transparent;\n  transform: translate(0, 0);\n  max-width: 300px;\n  min-height: 39px;\n  &:disabled {\n    padding-left: 11px;\n    padding-right: 11px;\n    border-color: ", ";\n    cursor: not-allowed;\n    filter: ", ";\n    opacity: ", ";\n    background: ", ";\n  }\n  &:active,\n  :focus {\n    outline: 0;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n  }\n\n  ", "\n"])), function (_ref2) {
  var cursor = _ref2.cursor;
  return cursor || 'pointer';
}, _constant.colors.H_WHITE, function (_ref3) {
  var color = _ref3.color;
  return color || _constant.colors.H_DARK;
}, _constant.colors.H_GREY, function (_ref4) {
  var noOpacity = _ref4.noOpacity,
    greyDisabled = _ref4.greyDisabled;
  return noOpacity || greyDisabled ? 'initial' : 'brightness(0.7)';
}, function (_ref5) {
  var noOpacity = _ref5.noOpacity,
    greyDisabled = _ref5.greyDisabled;
  return noOpacity || greyDisabled ? 1 : 0.9;
}, function (_ref6) {
  var color = _ref6.color,
    greyDisabled = _ref6.greyDisabled;
  return greyDisabled ? greyDisabled || _constant.colors.H_GREY : color || _constant.colors.H_GREY;
}, function (_ref7) {
  var $bsStyle = _ref7.$bsStyle;
  return $bsStyle || '';
});
exports.CustomButton = CustomButton;